import { PathfindingApp } from './PathfindingApp';

window.addEventListener('DOMContentLoaded', () => {
  new PathfindingApp();
});
